import { render, staticRenderFns } from "./ProofreadingAiConfirmDialog.vue?vue&type=template&id=7153e689&scoped=true"
import script from "./ProofreadingAiConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./ProofreadingAiConfirmDialog.vue?vue&type=script&lang=ts"
import style0 from "./ProofreadingAiConfirmDialog.vue?vue&type=style&index=0&id=7153e689&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7153e689",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7153e689')) {
      api.createRecord('7153e689', component.options)
    } else {
      api.reload('7153e689', component.options)
    }
    module.hot.accept("./ProofreadingAiConfirmDialog.vue?vue&type=template&id=7153e689&scoped=true", function () {
      api.rerender('7153e689', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/dialogs/ProofreadingAiConfirmDialog.vue"
export default component.exports